import CustomButton from "../common/CustomButton";
import CustomizableAvatar from "../common/CustomizableAvatar";
import MainAvatar from "../../assets/main-avatar.png";
import Smartlend from "../../assets/SMARTLEND.png";
import ReusableInput from "../common/ReusableInput";
import PermissionInput from "../common/PermissionInput";
import { useState } from "react";
import { Link } from "react-router-dom";
import { CloseIcon, SkipIcon } from "../common/IconComponents";
import { Formik } from "formik";

const options = [
  { value: "option1", label: "Admin" },
  { value: "option2", label: "Analyst" },
];

const ContinueAddTeam = () => {
  const [selectedOption, setSelectedOption] = useState(null);
  const [isButtonEnabled, setIsButtonEnabled] = useState(false);

  const handleOptionChange = (option) => {
    setSelectedOption(option);
    setIsButtonEnabled(option !== null);
  };
  return (
    <main>
      <section className="container my-0  mx-auto">
        <section>
          <div className=" p-4 px-4 md:p-8">
            <div className="grid gap-4 gap-y-2 text-sm grid-cols-1 lg:grid-cols-3">
              {/* <div className="px-4"> */}
              <CustomizableAvatar src={MainAvatar} className="px-1" />
              {/* </div> */}

              <div className=" px-10 lg:col-span-2 ">
                <CustomizableAvatar src={Smartlend} customClass={"pb-2"} />
                <p className="text-2xl py-3">Add team member</p>
                <form
                  className="container w-9/12"
                  onSubmit={Formik.handleSubmit}
                >
                  <ReusableInput
                    label="Work email address"
                    type="email"
                    placeholder="e.g. idowu.oluwatofunmi9@gmail.com"
                  // value={Formik.email}
                  // onChange={handleChange}
                  />

                  <PermissionInput
                    label="Permission"
                    options={options}
                    value={selectedOption}
                    onChange={handleOptionChange}
                  />

                  <div className="flex items-center justify-between my-5">
                    <CustomButton
                      className={
                        "bg-disabled-btn text-disabled cursor-not-allowed"
                      }
                      // onClick={handleAddMember}
                      disabled={!isButtonEnabled}
                    >
                      {/* <Link to={/home}>Add team member</Link> */}
                      Add team member
                    </CustomButton>
                  </div>

                  <span className="">
                    <div className="border-admin-border border rounded text-xs py-2 px-5 mb-1 w-3/6 flex items-center">
                      <span>oluwatofunmiidowu1@gmail.com</span>
                      <CloseIcon className="ml-1" />
                    </div>
                    <div className="border-admin-border border rounded text-xs py-2 px-5 mb-1 w-3/6 flex items-center">
                      <span>oluwatofunmiidowu1@gmail.com</span>
                      <CloseIcon className="ml-1" />
                    </div>
                  </span>

                  <div className="flex items-center justify-between mt-4">
                    <CustomButton
                      className={"bg-enabled-btn text-white"}
                      // onClick={handleAddMember}
                      disabled={!isButtonEnabled}
                    >
                      {/* <Link to={/home}>Add team member</Link> */}
                      <Link to={"/uploadLogo"}>Continue</Link>
                    </CustomButton>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </section>
      </section>
    </main>
  );
};

export default ContinueAddTeam;
